import { render, staticRenderFns } from "./leftnavmenu.vue?vue&type=template&id=12c7183a"
import script from "./leftnavmenu.vue?vue&type=script&lang=js"
export * from "./leftnavmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarItems})
